var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColombia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M19.9048 0.5H2.09524C0.93807 0.5 0 1.45513 0 2.63333V14.3667C0 15.5449 0.93807 16.5 2.09524 16.5H19.9048C21.0619 16.5 22 15.5449 22 14.3667V2.63333C22 1.45513 21.0619 0.5 19.9048 0.5Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5H22V8.5H0V0.5Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.5H22V16.5H0V12.5Z",
    fill: "#F93939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4315_131"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColombia);
export default __webpack_public_path__ + "static/media/colombia.2e3233d21c45503e3bda795d363c2dec.svg";
export { ForwardRef as ReactComponent };